import { TableCell, TableRow, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const TradeLogsRow = (log) => {
    const { type, messageType, time, message } = log.data;
    const theme = useTheme();
    
    // Determine the background color based on message type
    const getBackgroundColor = () => {
        if (messageType === "OrderCancelReject") {
            return theme.palette.error.dark; // Red for rejections
        } else if (type === "OUT") {
            return theme.palette.primary.main; // Default for outgoing messages
        } else {
            return theme.palette.primary.main; // Default for other messages
        }
    };

    // Format the message with better readability
    const formatMessage = (msg) => {
        if (!msg) return '';
        
        // If it's a cancel rejection, format it nicely
        if (messageType === "OrderCancelReject") {
            return (
                <Box component="span" sx={{ color: theme.palette.error.contrastText }}>
                    ❌ {msg}
                </Box>
            );
        }
        
        // For cancel requests
        if (messageType === "OrderCancelRequest") {
            return (
                <Box component="span" sx={{ color: theme.palette.warning.contrastText }}>
                    ⚠️ {msg}
                </Box>
            );
        }
        
        // For successful order cancellations
        if (messageType === "OrderCanceled") {
            return (
                <Box component="span" sx={{ color: theme.palette.success.contrastText }}>
                    ✓ {msg}
                </Box>
            );
        }
        
        return msg;
    };
    const formatMicroseconds = (timestamp)=> {
        const match = timestamp.match(/\.(\d{6})/);
        if (!match) return fallbackFormat(timestamp);
        
        const microseconds = match[1];
        const fourDecimalPlaces = microseconds.substring(0, 4);
        
        const date = new Date(timestamp);
        const time = date.toLocaleTimeString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        
        return `${time}.${fourDecimalPlaces}`;
    };
    const fallbackFormat = (timestamp)=> {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) + '.0000';
    };

    return (
        <TableRow
            sx={{
                "& .MuiTableCell-root": {
                    borderBottom: "none",
                    px: 1,
                    py: 1.5,
                },
                backgroundColor: getBackgroundColor(),
                borderRadius: "4px",
                "& td:first-of-type": {
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                },
                "& td:last-child": {
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px",
                },
                "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                },
            }}
        >
            <TableCell>
                <Typography sx={{ fontSize: '11px' }} noWrap>
                    {/* {new Date(time).toLocaleTimeString()} */}
                    {formatMicroseconds(time)}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography sx={{ fontSize: '11px' }} noWrap>
                    {type}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography sx={{ fontSize: '11px' }} noWrap>
                    {messageType}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography sx={{ fontSize: '11px' }} component="div" noWrap>
                    {formatMessage(message)}
                </Typography>
            </TableCell>
        </TableRow>
    );
};
